import { NotificationProductCode } from '@gb-ticket/shared-types';

/**
 * Whether a product block belongs on `/profil` Mitteilungen.
 * Same list as session `products[]` (installed ∩ qualified). Platform is always shown.
 */
export function shouldShowNotificationProductInProfile(
  productCode: NotificationProductCode,
  input: {
    sessionProducts: ReadonlySet<string>;
  },
): boolean {
  if (productCode === NotificationProductCode.PLATFORM) {
    return true;
  }
  return input.sessionProducts.has(productCode);
}
